<template>
  <div id="appbar">
    <v-app-bar app elevation="0" class="white">
      <div
        class="d-flex justify-space-between align-center"
        style="width: 100%"
      >
        <div class="d-flex align-center" style="margin-left: 12px">
          <v-app-bar-nav-icon @click.stop="TOGGLE_SIDEBAR()" />

          <v-btn
            v-if="isSiteClean && canGoBack"
            icon
            class="ml-2"
            @click="goBack"
          >
            <v-icon size="32" color="black" class="font-weight-bold">
              mdi-arrow-left
            </v-icon>
          </v-btn>

          <div
            v-if="
              isAnalystModule ||
              isExpertModule ||
              isUnderPerf ||
              isLossesWaterfall
            "
          >
            <h3 class="ml-2 font-weight-medium">
              {{ $t("_analyse_") }} -
              <router-link :to="{ path: routerLinkPath }">
                {{ pageLabel }}
              </router-link>
            </h3>
          </div>
          <h3 v-else class="font-weight-medium ml-2" style="width: 50%">
            {{ pageLabel }}
          </h3>

          <slot name="custom-selectors"></slot>

          <dates-selector-main
            v-if="show_date_selector"
            :store_date="$store.getters.dates"
            :min_date="auditDates.start"
            :max_date="auditDates.end"
            :show_label="false"
            store_cal_event="SET_MAIN_CALENDAR_REFRESH"
            store_date_commit="SET_DATES"
            class="ml-15 mt-3"
          />
          <div
            v-if="isSiteClean"
            class="ml-4 d-flex flex-column red--text"
            style="font-size: 12px; line-height: 1.2"
          >
            <div style="white-space: nowrap">
              <strong>{{ $t("_last_update_") }}:</strong>
              <span class="ml-2">{{ lastUpdate }}</span>
            </div>

            <div style="white-space: nowrap">
              <strong>{{ $t("_next_update_") }}:</strong>
              <span class="ml-2">{{ nextUpdate }}</span>
            </div>
          </div>
          <slot></slot>
        </div>

        <div class="d-flex align-center">
          <div class="mr-6">
            <flags />
          </div>
          <div class="mr-4">
            <img
              :src="picture"
              width="50"
              height="50"
              style="border-radius: 50%"
            />
          </div>
          <div>
            <v-menu offset-y left content-class="appbar-user-menu">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" small text v-bind="attrs" v-on="on">
                  <small class="mr-2 font-weight-medium">{{ name }}</small>
                  <small class="grey--text capitalize">{{ role }}</small>
                  <v-icon right small>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-card min-width="220" class="rounded-lg">
                <v-list class="elevation-4" dense>
                  <v-list-item
                    class="menu-item-appbar"
                    link
                    @click="showSettings = true"
                  >
                    <v-list-item-icon>
                      <v-icon small>mdi-cog</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                      {{ $t("_parameters_") }}
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item class="menu-item-appbar" to="/logout">
                    <v-list-item-icon>
                      <v-icon small color="red">mdi-logout</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="red--text">
                      {{ $t("_se_deconnecter_") }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </div>
          <!-- <div>
            <small class="mr-2 font-weight-medium">{{ name }}</small>
            <small class="grey--text capitalize">{{ role }}</small>
            <router-link class="red--text d-flex align-center" to="/logout">
              <small>{{ $t("_se_deconnecter_") }}</small>
            </router-link>
          </div>-->
        </div>
      </div>
    </v-app-bar>
    <v-dialog v-model="showSettings" max-width="500">
      <v-card>
        <v-card-title>
          {{ $t("_parameters_") }}
        </v-card-title>

        <v-card-text>
          <v-select
            v-model="language"
            :items="languages"
            :label="$t('_language_')"
            item-text="label"
            item-value="code"
            outlined
            dense
          >
            <template v-slot:item="{ item }">
              <div class="d-flex align-center">
                <gb-flag :code="item" size="small" class="mr-3" />
                <span>{{ item.toUpperCase() }}</span>
              </div>
            </template>

            <template v-slot:selection="{ item }">
              <div class="d-flex align-center">
                <gb-flag :code="item" size="small" class="mr-2" />
                <span>{{ item.toUpperCase() }}</span>
              </div>
            </template>
          </v-select>

          <v-switch v-model="emailNotifications">
            <template v-slot:label>
              <v-icon
                :color="emailNotifications ? 'green' : 'red'"
                class="mr-2"
              >
                {{ emailNotifications ? "mdi-check" : "mdi-close" }}
              </v-icon>

              {{ $t("_email_notification_") }}
            </template>
          </v-switch>

          <v-switch v-model="weeklyReports">
            <template v-slot:label>
              <v-icon :color="weeklyReports ? 'green' : 'red'" class="mr-2">
                {{ weeklyReports ? "mdi-check" : "mdi-close" }}
              </v-icon>

              {{ $t("_reports_") }}
            </template>
          </v-switch>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="showSettings = false">
            {{ $t("_annuler_") }}
          </v-btn>

          <v-btn color="primary" @click="saveSettings">
            {{ $t("_apply_") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";

import DatesSelectorMain from "@/components/Utils/DatesSelector";
import Flags from "@/components/UI_kit/Flags";
import data_tsl from "@/data/country_code.js";
import tsl from "@/utils/translation.js";
import api from "@/api/api";
import Swal from "sweetalert2";

export default {
  components: {
    DatesSelectorMain,
    Flags,
  },

  data() {
    return {
      dates: {
        start: this.$store.getters.dates.start,
        end: this.$store.getters.dates.end,
      },
      showSettings: false,
      auditDates: this.$store.getters.auditDates,
      show_date_selector: false,
      installation_name: "",
      lastUpdate: "",
      nextUpdate: "",

      emailNotifications: false,
      weeklyReports: false,
      language: null,
      languages: tsl.getLangList(data_tsl.allowed_country),
    };
  },

  methods: {
    ...mapMutations(["TOGGLE_SIDEBAR"]),

    goBack() {
      this.$router.push("/dashboard-clean");
    },

    async loadSettings() {
      try {
        const { data } = await api.getParameters();

        this.emailNotifications = data.email_notif;
        this.weeklyReports = data.report_notif;
        this.language = tsl.getIETFCountry(data.language);
      } catch (err) {
        console.error(err);
      }
    },

    getAnalysisMode() {
      let analysisModeLabel = "";
      const analysisMode = this.$store.getters.installations.find(
        (x) => x.id === this.$route.params.id
      )?.analysis_mode;

      if (analysisMode === "continuous") {
        analysisModeLabel = this.$t("_mon_installation_");
      } else {
        analysisModeLabel = this.$t("_mon_audit_");
      }

      return analysisModeLabel;
    },

    computePageLabel() {
      let sectionLabel = "";
      this.show_date_selector = false;

      if (this.$route.name === "installation-show") {
        this.show_date_selector = true;
        sectionLabel = `${this.getAnalysisMode()} - ${this.installation_name}`;
      } else if (
        this.$route.name !== null &&
        (this.$route.name.startsWith("expert") ||
          this.$route.name.startsWith("analyst"))
      ) {
        sectionLabel = this.installation_name;
      } else if (
        this.$route.name !== null &&
        ["1_niv1_evo-sous-perf", "dashboard-losses-waterfall"].includes(
          this.$route.name
        )
      ) {
        this.show_date_selector = true;
        sectionLabel = this.installation_name;
      } else if (
        this.$route.name !== null &&
        (this.isUnderPerf || this.isLossesWaterfall)
      ) {
        sectionLabel = this.installation_name;
      } else if (this.$route.name !== null && this.isSmartguardFleet) {
        sectionLabel = this.$t("_fleet_");
      } else if (this.$route.name !== null && this.isSmartguardSite) {
        sectionLabel = "SMART GUARD -" + " " + this.installation_name;
      } else if (this.$route.name !== null && this.isFleetClean) {
        sectionLabel = this.$t("_fleet_clean_");
      } else if (this.$route.name !== null && this.isSiteClean) {
        sectionLabel = "HELIO CLEAN -" + " " + this.installation_name;
      } else if (
        this.$route.name !== null &&
        ["dashboard-manager"].includes(this.$route.name)
      ) {
        sectionLabel = this.$t("_fleet_manager_");
      } else {
        sectionLabel = this.$t("_analyse_"); //this.$route.meta.label
      }

      return sectionLabel;
    },
    async saveSettings() {
      try {
        const locale = tsl.buildIETFCountryLang(this.language);

        await api.updateSettings({
          language: locale,
          email_notif: this.emailNotifications,
          report_notif: this.weeklyReports,
        });

        await Swal.fire({
          icon: "info",
          title: this.$t("_information_"),
          text: this.$t("_notice_"),
        });

        this.showSettings = false;
      } catch (error) {
        console.error(error);

        Swal.fire({
          icon: "error",
          title: this.$t("_error_"),
          text: this.$t("_something_went_wrong_"),
        });
      }
    },
    async getLastUpdateDate() {
      if (this.$route.params.id != undefined) {
        const response = await api.getLastUpdatedDate(this.$route.params.id);
        this.lastUpdate = response.data;
        const nextDate = new Date(this.lastUpdate);
        nextDate.setDate(nextDate.getDate() + 1);

        this.nextUpdate = nextDate.toISOString().slice(0, 10);
      }
    },
  },

  watch: {
    "$route.params.id": {
      handler: function (id) {
        if (id != undefined) {
          this.installation_name = this.$store.getters.installations.find(
            (x) => x.id == id
          )?.installation_name;

          if (this.isSiteClean) {
            this.getLastUpdateDate();
          }
        }
      },
      immediate: true,
    },
    async showSettings(val) {
      if (val) {
        await this.loadSettings();
      }
    },
  },

  computed: {
    ...mapGetters(["appTitle", "name", "picture", "role"]),

    user() {
      return this.$store.state.authStore;
    },

    langCode() {
      return this.$store.getters.lang_code;
    },
    canGoBack() {
      return this.isSiteClean;
    },

    routerLinkPath() {
      const fromSG = this.$route.query.fromSmartguard;
      if (fromSG === true || fromSG === "true") {
        return `/smart-guard/${this.$route.params.id}`;
      }
      return `/installations/show/${this.$route.params.id}`;
    },

    isExpertModule() {
      if (this.$route.name !== null)
        return this.$route.name.startsWith("expert");
      else return false;
    },

    isAnalystModule() {
      if (this.$route.name !== null)
        return this.$route.name.startsWith("analyst");
      else return false;
    },

    isUnderPerf() {
      if (this.$route.name !== null)
        return this.$route.name === "dashboard-under-perf";
      else return false;
    },

    isLossesWaterfall() {
      if (this.$route.name !== null)
        return this.$route.name === "dashboard-losses-waterfall";
      else return false;
    },

    isSmartguardFleet() {
      if (this.$route.name !== null)
        return this.$route.name === "dashboard-fleet";
      else return false;
    },
    isSmartguardSite() {
      if (this.$route.name !== null) return this.$route.name === "smart-guard";
      else return false;
    },
    isFleetClean() {
      if (this.$route.name !== null)
        return this.$route.name === "dashboard-clean";
      else return false;
    },
    isSiteClean() {
      return this.$route.name?.startsWith("helio-clean");
    },

    pageLabel() {
      return this.computePageLabel();
    },
  },
};
</script>

<style lang="scss" scoped>
#appbar {
  border-bottom: 1px solid #ededed !important;
}

a:hover {
  opacity: 0.7;
  text-decoration: underline;
}
.appbar-user-menu {
  z-index: 10000 !important;
}
</style>
<style>
.v-app-bar h3,
#appbar h3 {
  white-space: nowrap !important;
  flex-shrink: 0 !important;
}

#appbar .d-flex.align-center {
  flex-wrap: nowrap !important;
}
#appbar .v-menu__content {
  min-width: 40px !important;
  z-index: 1300;
}
.menu-item-appbar:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}
.menu-item-appbar {
  border: 1px solid #e0e0e0;
  margin: 4px;
  border-radius: 6px;
}
</style>
